/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SafeSize } from './SafeSize';
import {
    SafeSizeFromJSON,
    SafeSizeFromJSONTyped,
    SafeSizeToJSON,
    SafeSizeToJSONTyped,
} from './SafeSize';
import type { ServiceAgreementPropertiesType } from './ServiceAgreementPropertiesType';
import {
    ServiceAgreementPropertiesTypeFromJSON,
    ServiceAgreementPropertiesTypeFromJSONTyped,
    ServiceAgreementPropertiesTypeToJSON,
    ServiceAgreementPropertiesTypeToJSONTyped,
} from './ServiceAgreementPropertiesType';
import type { SafeLocation } from './SafeLocation';
import {
    SafeLocationFromJSON,
    SafeLocationFromJSONTyped,
    SafeLocationToJSON,
    SafeLocationToJSONTyped,
} from './SafeLocation';

/**
 * 
 * @export
 * @interface SafeDepositBoxServiceAgreementProperties
 */
export interface SafeDepositBoxServiceAgreementProperties {
    /**
     * 
     * @type {SafeLocation}
     * @memberof SafeDepositBoxServiceAgreementProperties
     */
    safeLocation?: SafeLocation;
    /**
     * 
     * @type {SafeSize}
     * @memberof SafeDepositBoxServiceAgreementProperties
     */
    safeSize?: SafeSize;
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxServiceAgreementProperties
     */
    safeNr?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SafeDepositBoxServiceAgreementProperties
     */
    keyDeposit?: boolean;
    /**
     * 
     * @type {ServiceAgreementPropertiesType}
     * @memberof SafeDepositBoxServiceAgreementProperties
     */
    propertiesType: ServiceAgreementPropertiesType;
    /**
     * resolved server-side: true if the current user may edit the safe number, independently of whether the box is otherwise editable or already configured. Ignored if sent back on write.
     * 
     * @type {boolean}
     * @memberof SafeDepositBoxServiceAgreementProperties
     */
    canEditSafeNumber?: boolean;
    /**
     * resolved server-side: true if the current user may edit the safe location and size fields. False when safe number has been configured by CDS and the current user is not CDS. Ignored if sent back on write.
     * 
     * @type {boolean}
     * @memberof SafeDepositBoxServiceAgreementProperties
     */
    canEditSafeDepositBoxLocation?: boolean;
    /**
     * resolved server-side: true if the current user may change the key deposit, in either direction. False once the box has been activated and the current user is not CDS. Ignored if sent back on write.
     * 
     * @type {boolean}
     * @memberof SafeDepositBoxServiceAgreementProperties
     */
    canEditKeyDeposit?: boolean;
}



/**
 * Check if a given object implements the SafeDepositBoxServiceAgreementProperties interface.
 */
export function instanceOfSafeDepositBoxServiceAgreementProperties(value: object): value is SafeDepositBoxServiceAgreementProperties {
    if (!('propertiesType' in value) || value['propertiesType'] === undefined) return false;
    return true;
}

export function SafeDepositBoxServiceAgreementPropertiesFromJSON(json: any): SafeDepositBoxServiceAgreementProperties {
    return SafeDepositBoxServiceAgreementPropertiesFromJSONTyped(json, false);
}

export function SafeDepositBoxServiceAgreementPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxServiceAgreementProperties {
    if (json == null) {
        return json;
    }
    return {
        
        'safeLocation': json['safeLocation'] == null ? undefined : SafeLocationFromJSON(json['safeLocation']),
        'safeSize': json['safeSize'] == null ? undefined : SafeSizeFromJSON(json['safeSize']),
        'safeNr': json['safeNr'] == null ? undefined : json['safeNr'],
        'keyDeposit': json['keyDeposit'] == null ? undefined : json['keyDeposit'],
        'propertiesType': ServiceAgreementPropertiesTypeFromJSON(json['propertiesType']),
        'canEditSafeNumber': json['canEditSafeNumber'] == null ? undefined : json['canEditSafeNumber'],
        'canEditSafeDepositBoxLocation': json['canEditSafeDepositBoxLocation'] == null ? undefined : json['canEditSafeDepositBoxLocation'],
        'canEditKeyDeposit': json['canEditKeyDeposit'] == null ? undefined : json['canEditKeyDeposit'],
    };
}

export function SafeDepositBoxServiceAgreementPropertiesToJSON(json: any): SafeDepositBoxServiceAgreementProperties {
    return SafeDepositBoxServiceAgreementPropertiesToJSONTyped(json, false);
}

export function SafeDepositBoxServiceAgreementPropertiesToJSONTyped(value?: SafeDepositBoxServiceAgreementProperties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'safeLocation': SafeLocationToJSON(value['safeLocation']),
        'safeSize': SafeSizeToJSON(value['safeSize']),
        'safeNr': value['safeNr'],
        'keyDeposit': value['keyDeposit'],
        'propertiesType': ServiceAgreementPropertiesTypeToJSON(value['propertiesType']),
        'canEditSafeNumber': value['canEditSafeNumber'],
        'canEditSafeDepositBoxLocation': value['canEditSafeDepositBoxLocation'],
        'canEditKeyDeposit': value['canEditKeyDeposit'],
    };
}

